<script setup lang="ts">
import { VueperSlides, VueperSlide } from 'vueperslides'
import { useScreen } from '@/composables/useScreen'

import { defineProps } from 'vue'
const props = defineProps({
  heading: {
    type: String,
    default: null
  },
  steps: {
    type: Array,
    default: () => null
  }
})

const { isMobileView } = useScreen()
const steps = props.steps || [
    {
      label: 'how_it_works_describe_problem',
      text: 'describe_your_problem_longer_version',
      imageName: 'Describe.png',
    },
    {
      label: 'select_lawyer',
      text: 'select_lawyer_description',
      imageName: 'Lawyers.png'
    },
    {
      label: 'schedule_meeting2',
      text: 'schedule_meeting_description',
      imageName: 'Calendar.png'
    },
    {
      label: 'attend_meeting',
      text: 'attend_meeting_description',
      imageName: 'Meeting.jpeg'
    }
  ]
const currentStep = ref(0)
</script>
<template>
  <div class="container font-redhat text-white bg-darkBlue lg:bg-transparent">
    <div class="bg-darkBlue lg:min-h-[584px] lg:rounded-[40px] py-12 lg:py-20 lg:px-10 xl:px-[70px] lg:flex">

      <div class="text-[36px] lg:text-[60px] w-full lg:w-auto flex justify-center lg:absolute">
        {{ props.heading || $t('how_it_works') }}?
      </div>

      <div v-if="isMobileView">
        <vueper-slides
          class="no-shadow"
          fixed-height="650px"
          :arrows="true"
          :gap="0"
          bullets-outside
          :autoplay="false"
          :pauseOnHover="false"
          :pauseOnTouch="true"
          :preventYScroll="true"
          :dragging-distance="70"
        >
          <template #bullet="{ active }">
            <div class="relative w-[25px] h-[4px] -mx-[6px] top-[34px] bg-white" :class="{'opacity-55' : !active}" />
          </template>
          <template #arrow-left>
            <div class="relative top-[385px]" style="left: -113px">
              <IconArrowFullLeft class="text-white" />
            </div>
          </template>
          <template #arrow-right>
            <div class="relative top-[385px]" style="right: -113px">
              <IconArrowFullRight class="text-white" />
            </div>
          </template>
          <vueper-slide v-for="(step, index) in steps" :key="index">
            <template #content>
              <div class="mt-2 flex items-center justify-center font-branding px-3">
                <div class="xs:max-w-[400px]">
                  <div class="flex justify-center">
                    <img :src="`/images/HowItWorks/${step.imageName}`" alt="howItWorksImage" class="max-w-[360px] xs:max-w-[400px] max-h-[320px] xs:max-h-[400px] rounded-[40px] mt-8">
                  </div>

                  <div class="mt-10 flex items-center text-sm">
                    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1.5">
                      <circle cx="4" cy="4" r="4" fill="white"/>
                    </svg>
                    {{ $t(step.label) }}
                  </div>

                  <div class="mt-6">
                    <div class="text-[36px] leading-none font-redhat">
                      {{ $t(step.label) }}
                    </div>
                    <div class="mt-6 font-branding">
                      {{ $t(step.text) }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </vueper-slide>
        </vueper-slides>
      </div>

      <div v-else class="flex items-center w-full">
        <div class="w-1/5 mt-10">
          <div>
            <div v-for="(step, index) in steps" :key="index">
              <div v-if="index > 0" :class="{'opacity-40' : index > currentStep}">
                <svg width="8" height="28" viewBox="0 0 8 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3.5" width="1" height="28" fill="white"/>
                </svg>
              </div>
              <button :class="{'opacity-40' : index > currentStep}" @click="currentStep = index" class="text-sm">
                <div class="flex items-center">
                  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1.5">
                    <circle cx="4" cy="4" r="4" fill="white"/>
                  </svg>
                  {{ $t(step.label) }} 
                </div>
              </button>
            </div>
          </div>
        </div>

        <div class="mt-10 mx-4">
          <div class="max-w-[368px]">
            <div class="text-[52px] leading-none">
              {{ $t(steps[currentStep].label) }}
            </div>
            <div class="mt-6 font-branding">
              {{ $t(steps[currentStep].text) }}
            </div>
          </div> 
        </div>

        <div class="ml-auto flex items-center">
          <img :src="`/images/HowItWorks/${steps[currentStep].imageName}`" alt="howItWorksImage" class="max-w-[360px] xl:max-w-[450px] max-h-[320px] xl:max-h-[400px] rounded-[40px]">
        </div>
      </div>

    </div>
  </div>
</template>
<style scoped>
:deep(.vueperslides__arrow) {
  opacity: 1;
}

:deep(.vueperslides__arrow--prev) {
  left: 50%;
}

:deep(.vueperslides__arrow--next) {
  right: 50%;
}
</style>